import React from "react";
import { MessageCircleIcon } from "lucide-react";

interface WhatsAppFloatButtonProps {
  phoneNumber?: string;
  message?: string;
}

export const WhatsAppFloatButton: React.FC<WhatsAppFloatButtonProps> = ({
  phoneNumber = "6281234567890", // Default Indonesian number format
  message = "Halo, saya butuh bantuan dengan AdapTeach",
}) => {
  const handleWhatsAppClick = () => {
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 group">
      {/* Tooltip */}
      <div className="absolute bottom-full right-0 mb-4 px-3 py-2 bg-gray-800 text-white text-sm rounded-lg shadow-lg duration-300 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
        Butuh Bantuan? Hubungi Kami
        <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
      </div>

      {/* Floating Button */}
      <button
        onClick={handleWhatsAppClick}
        className="relative w-16 h-16 bg-green-500 hover:bg-green-600 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center transform hover:scale-110"
        aria-label="Hubungi kami via WhatsApp"
      >
        <MessageCircleIcon className="w-8 h-8 text-white" />

        {/* Pulse animation */}
        <div className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-20"></div>
      </button>
    </div>
  );
};
